import {isExternal} from '@/utils/validate';
// @ts-ignore
import path from 'path';
import Component, {mixins} from 'vue-class-component';

import {Prop} from 'vue-property-decorator';
import FixiOSBug from './fix-ios-bug';
import Item from './Item.vue';
import AppLink from './Link.vue';

@Component({
  name: 'SidebarItem',
  components: {AppLink}
})
export default class SidebarItem extends mixins(FixiOSBug) {
  @Prop({
    type: Object,
    required: true
  })
  public item: any;
  @Prop({
    type: Boolean,
    default: false
  })
  public isNest!: boolean;
  @Prop({
    type: String,
    default: ''
  })
  public basePath!: string;
  public onlyOneChild = null;

  public hasOneShowingChild(children: any[] = [], parent) {
    if (!children) {
      children = [];
    }
    const showingChildren = children.filter(item => {
      if (item.hidden) {
        return false;
      } else {
        // Temp set(will be used if only has one showing child)
        this.onlyOneChild = item;
        return true;
      }
    });

    // When there is only one child router, the child router is displayed by default
    if (showingChildren.length === 1) {
      return true;
    }

    // Show parent if there are no child router to display
    if (showingChildren.length === 0) {
      this.onlyOneChild = {...parent, path: '', noShowingChildren: true};
      return true;
    }

    return false;
  }

  public resolvePath(routePath) {
    if (isExternal(routePath)) {
      return routePath;
    }
    if (isExternal(this.basePath)) {
      return this.basePath;
    }
    return path.resolve(this.basePath, routePath);
  }

  public render(ctx) {
    const item = this.item;
    const hasOneShowingChild = this.hasOneShowingChild(item.children, item);
    const onlyOneChild: any = this.onlyOneChild;
    if (hasOneShowingChild && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow) {
      if (onlyOneChild.meta) {
        // @ts-ignore
        return <AppLink to={this.resolvePath(onlyOneChild.path)}>
          <el-menu-item class={{'submenu-title-noDropdown': !this.isNest}}
                        index={this.resolvePath(onlyOneChild.path)}
          >
            {
              // @ts-ignore
              <Item icon={onlyOneChild.meta.icon || (item.meta && item.meta.icon)}
                    title={onlyOneChild.meta.title}
              />
            }
          </el-menu-item>
        </AppLink>;
      }
      return;
    } else {
      return <el-submenu ref="subMenu"
                         index={this.resolvePath(item.path)}
                         popper-append-to-body={true}
      >
        <template slot="title">
          {
            // @ts-ignore
            item.meta ? <Item icon={item.meta && item.meta.icon}
                              title={item.meta.title}
            /> : null
          }
        </template>
        {
          item.children.map(child => {
            return <sidebar-item key={child.path}
                                 base-path={this.resolvePath(child.path)}
                                 is-nest={true}
                                 item={child}
                                 class="nest-menu"
            />;
          })
        }
      </el-submenu>;
    }
  }
}
